
import Vue from 'vue'
import moment from 'moment'
import util,{_} from '@/libs/util'
import auth from '@/libs/auth'
import common from '@/libs/common.mixin'
import wxjssdk from '@/libs/wxjssdk.mixin'
import globals from '@/libs/globals.mixin'
import MyRater from 'c%/MyRater.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Rater from 'vux/src/components/rater/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import { Col, Row, Dialog } from 'vant'
import FileItem from 'c%/FileItem.vue'

export default{
mixins: [common,wxjssdk,globals],
components: {
Rater,
FileItem,
MyRater,
Flexbox,
XButton,
FlexboxItem,
XTextarea,
[Col.name]:Col,
[Row.name]:Row,
"van-dialog": Dialog.Component
},
data () {
return {
info: {},
loading: false,
active_voice: -1,
showPanel: false,
raterVal: 5,
eva_ok: false,
cBtnText: "回评",
t_list: {},
ready: false,
photo: 'http://s1.xiao360.com/common_img/avatar.jpg',
content: '',
source: [],
popup_video: false,
mapContent: {'lesson_after_task':'课后作业','lesson_content':'上课内容','next_task':'下堂课内容'},
}
},
mounted () {
this.init()
},
watch: {
ready: function (val) {
if(!val) {
this.showLoading()
}else{
this.hideLoading()
}
},
'raterVal':function(v){
if(v > 0 && v <= 3 && this.is_xtjy){
let text = v == 1 ? '一' : v == 2 ? '二' : '三';
Dialog.alert({
title: '提示',
message: text + '星回评代表对督导员不满意，还请将你的建议反馈给学管师哦~',
})
}
}
},
computed: {
isLogin() {
return auth.isLogin()
},
systemName () {
let result = ''
if(!_.isEmpty(window.CLIENT_PARAMS.mobile) && window.CLIENT_PARAMS.mobile.system_name != ''){
result = window.CLIENT_PARAMS.mobile.system_name
}
return result
},
sheduleDate () {
let result = ''
if(this.info.int_day){
result = moment(this.$filter('int_date')(this.info.int_day)).format('YYYY年MM月DD日')
}
return result
},
activeStar () {
return `<img slot="active" src="/static/img/student/star-sel.png" style="width:16px">`
},
defaultStar () {
return `<img slot="default" src="/static/img/student/star-nor.png" style="width:16px">`
},
currentTpl () {
let review = this.info.review,
result = {}
if(review){
result = review.review_tpl_setting
}

return result
},
content_fields () {
let result = {},
fields = this.currentTpl.setting?this.currentTpl.setting.common_fields:{}
for(let s in fields){
let obj = fields[s]
if(obj.enable==1&&obj.student_view==1){
result[s] = {}
result[s].label = obj.label
result[s].value = obj.tpl
}
}

return result
},
content_value () {
let result = {}
if(!_.isEmpty(this.info)){
if(this.info.review){
result = JSON.parse(this.info.review.content)
}
}
return result
},
scores () {
let result = {},
fields = this.currentTpl.setting?this.currentTpl.setting.score_fields:{}

return fields
},
is_show_score(){
let score = this.info.review_student_score

return score && (parseFloat(score.correct_score) > 0
|| parseFloat(score.enter_score) > 0
|| parseFloat(score.homework_score) > 0
|| parseFloat(score.overall_score) > 0
|| parseFloat(score.performance_score) > 0
|| parseFloat(score.practice_score) > 0)
}
},
methods: {
nlbr(val){
return val.replace(/[\n\r]+/g,'<br>')
},
html_content(content){
content = content || '未填写'
return this.nlbr(content)
},
getVOptions (row){
return {
autoplay: false,
volume: 0.6,
poster: row.file_url+'?vframe/jpg/offset/1/w/130/h/130'
}
},
preview_video (row) {
let obj = util.copy(row)
obj.src = row.file_url
this.source = [obj]
this.popup_video = true
},
showLoading () {
this.$vux.loading.show({
text: 'Loading'
})
},
hideLoading () {
setTimeout(()=>{
this.$vux.loading.hide()
},300)
},
doRead(rs_id) {
this.$rest('share').add_url_param(rs_id,'doRead')
.post()
.success(res => {})
.error(res => {})
},
init () {
this.showLoading()
this.init_data()
},
init_data(scroll) {

this.ready = false
this.$rest('share/my_review_detail?with=one_class&rs_id='+this.$route.params.id)
.get()
.success(data=>{
if(data.is_read==0) {
this.doRead(data.rs_id)
}

if(data.review_style == 1) {
this.$vux.loading.hide();
this.$router.replace('/style-reviews/'+this.$route.params.id)
}else if(data.review_style == 2){
this.$vux.loading.hide();
this.$router.replace('/style-reviews2/'+this.$route.params.id)
}

this.info = data;
if(data.employee.photo_url) {
this.photo = data.employee.photo_url;
}

this.ready = true
this.setShare()

if(auth.isLogin()) {
var that = this;
this.$rest('comments')
.get({
app_name: 'teacher',
app_content_id: that.info.rvw_id
})
.success(data=>{
if(data.list.length != 0) {
that.cBtnText = '撤销';
that.t_list = data.list[0];
that.eva_ok = true;
}else{
that.cBtnText = '回评';
that.t_list = {};
that.eva_ok = false;
}
if(scroll) {
this.$nextTick(() => {
document.getElementById('review-detail').scrollIntoView({behavior: 'smooth',block:scroll})
})
}

}).error(response=>{
that.toast(response.body.message||'获取详情失败~','warn')
})
}
})
},
setShare () {
let [title,img,desc] = [this.info.student.student_name+'的个人点评','',this.info.detail],
imgList = this.imglist()

if(imgList.length>0){
img = imgList[0]
}

this.setWxShare(title,img,desc)
.then(()=>{

this.share()
},()=>{})
},
share () {
this.$rest('share/after_share_review?rs_id='+this.$route.params.id)
.get()
.success(data=>{
this.alert('分享成功','分享成功',true)
}).error(response=>{
console.log('error')
console.log(response)
this.alert('分享失败',response.body.message||'分享失败了')
})
},
labelScore (index) {
let scoreFields = this.scores
if(!_.isEmpty(scoreFields)){
return scoreFields['score'+(index>0?index:'')].label
}
return ''
},
file_list (type) {
let [result,review] = [[],this.info.review]

if(type=='image'){
type = ['image','gif','jpg','jpeg','png','bmp','webp']
}else if(type=='voice'){
type = ['voice','mp3','wav','wma','ogg','aac','flac']
}else if(type=='video'){
type = ['video','mp4','m3u8','rmvb','avi','swf','3gp','mkv','flv']
}else{
type = ['numbers','csv','xls','xlsx','keynote','ppt','pptx']
}

if(review&&review.review_file.length>0){
result = review.review_file.filter(u=>type.indexOf(u.file_type)>-1)
}
return result
},
imglist () {
let list = this.file_list('image'),
result = []
if(list.length>0){
list.forEach(l=>{
result.push(l.file_url)
})
}
return result
},
btnClick() {
if(_.isEmpty(this.t_list)) {

this.showPanel = true;

}else{
this.deleteReply()
}
},
deleteReply() {
this.$vux.confirm.show({
title: '提示',
content: '确定要撤销对老师的回评吗',
onCancel: () => {

},
onConfirm: () => {
this.$rest('comments')
.delete(this.t_list.cmt_id)
.success(res => {
this.toast('撤销成功','success')
this.init_data('end')
})
.error(res => {
this.alert('撤销失败',res.body.message)
})
}
})
},
cancelComment(){
if(this.is_xtjy){
Dialog.confirm({
title: '提示',
message: '未回评会影响督导员的绩效，请给督导员回评哦~',
confirmButtonText: '继续回评',
cancelButtonText: '关闭'
})
.then(() => {

})
.catch(() => {
this.showPanel = false
});
}else{
this.showPanel = false
}
},
addComment() {
if(this.is_xtjy && this.raterVal == 0) {
this.$vux.toast.text('请给老师评星哦！', 'middle')
return false;
}
if(this.content == '') {
this.$vux.toast.text('内容未填写！', 'middle')
return false;
}
this.loading = true
this.$rest('comments/do_teacher_comment').post({
sid: this.info.sid,
rvw_id: this.info.rvw_id,
score: this.raterVal,
content: this.content,
eid: this.info.eid
})
.success(data=>{
this.loading = false
this.$vux.toast.text('提交成功！', 'middle');
this.showPanel = false;
this.init_data('end');
}).error(response=>{
this.loading = false
this.alert('提交失败',response.body.message)
})
},
textareaBlur() {
document.getElementById('review-detail').scrollIntoView({behavior: 'smooth',block:'start'})
}
}
}



// WEBPACK FOOTER //
// ./src/views/public/comment.vue